import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { tr } = useLanguage();

  return (
    <footer className="footer">
      <p className="footer-rights">{tr.footer.rights}</p>
      <a href="#inicio" className="footer-top" aria-label="Voltar ao topo">
        <img src="./assets/icons8-arrow-up-50.png" alt="Voltar ao topo" />
      </a>
    </footer>
  );
};

export default Footer;
